import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './Filter.scss';
import moment from 'moment';

// @ts-ignore
import { currencyFormatter } from '@mooncake/utils';
import Loader from '../Loader/Loader';
import { fetchDisplayPrice, formatLocale, sendEvent } from '../../../utils';

interface IFilterProps {
  context?: IContent;
  loading?: any;
  products?: any;
  onlyCollectorEdition?: boolean;
  title?: string;
  defaultSelected?: string;
}

const Filter = ({
                  context,
                  products,
                  onlyCollectorEdition,
                  loading,
                  title,
                  defaultSelected,
                  ...props
                }: IFilterProps) => {
  const { global, comparison_table } = context;

  let isProductsLoading = true;
  if (Object.keys(loading).length > 0) {
    isProductsLoading = Object.keys(loading).some(
      (loadingKey: any) => loading[loadingKey]
    );
  }

  const [selectedEditionId, setSelectedEditionId] = useState(null);
  const [selectedVariantId, setSelectedVariantId] = useState(null);

  const getVariationValue = (variant: any, variationAttribute: any) => {
    const valueVariationAttribute = variationAttribute.values.filter(
      (objectVariationAttributeValue: any) =>
        objectVariationAttributeValue.value ===
        variant.variation_values[variationAttribute.id]
    );
    const valueToReturn =
      valueVariationAttribute.length === 1
        ? valueVariationAttribute[0].description
        : null;
    return valueToReturn === 'PS4'
      ? 'PS4/PS5'
      : valueToReturn === 'Xbox One'
        ? 'Xbox One/Series X'
        : valueToReturn;
  };

  const getVariantsList = (productsVariants: any, variationAttribute: any) => {
    return productsVariants
      .filter(
        (productVariant: any) =>
          productVariant &&
          productVariant.variation_values &&
          !!productVariant.variation_values[variationAttribute.id]
      )
      .map((productVariant: any, index: number) => (
        <option value={productVariant.id} key={index}>
          {getVariationValue(productVariant, variationAttribute)}
        </option>
      ));
  };

  const changeSelectedEdition = (value: string) => {
    setSelectedEditionId(value);
    selectDefaultVariant(value);
  };

  const selectDefaultVariant = (masterEdition: string) => {
    if (
      products[masterEdition] &&
      products[masterEdition].originalData &&
      products[masterEdition].originalData.variants.length
    ) {
      const filteredVariants = products[masterEdition].originalData.variants;
      if (filteredVariants.length > 0) {
        setSelectedVariantId(filteredVariants[0].id);
      }
    }
  };

  const formatProductInfo = (productFound: any[]) => {
    const product = productFound[0];

    const releaseDate =
      selectedEditionId && selectedVariantId && products[selectedEditionId]
        ? products[selectedEditionId].originalData.c_productReleaseDateTime
        : null;

    const preOrderable = releaseDate
      ? releaseDate && moment(releaseDate) > moment()
      : true;

    const displayPrice = fetchDisplayPrice(product);

    const newPriceExists =
      displayPrice.promotionalPrice &&
      (typeof displayPrice.promotionalPrice === 'number' ||
        typeof displayPrice.promotionalPrice === 'string');

    const oldPriceExists =
      displayPrice.regular &&
      (typeof displayPrice.regular === 'number' ||
        typeof displayPrice.regular === 'string') &&
      displayPrice.regular !== displayPrice.promotionalPrice;

    return {
      ...product,
      displayPrice,
      newPriceExists,
      oldPriceExists,
      releaseDate,
      preOrderable,
      edition: product.c_productEditionString || ''
    };
  };

  const selectDefaults = (productsValues: any) => {
    const selectedEditionId = productsValues[0].id;

    setSelectedEditionId(selectedEditionId);
    selectDefaultVariant(selectedEditionId);
  };

  useEffect(() => {
    if (products) {
      const productsValues: any = Object.values(products);

      if (defaultSelected) {
        const editionFound = productsValues.filter((product: any) => {
          if (product.originalData && product.originalData.variants.length) {
            const foundInVariants = product.originalData.variants.filter(
              (variant: any) => variant.id === defaultSelected
            );
            return foundInVariants.length === 1;
          }
          return false;
        });
        if (editionFound.length === 1) {
          setSelectedEditionId(editionFound[0].id);
          setSelectedVariantId(defaultSelected);
        } else if (
          productsValues.length > 0 &&
          selectedEditionId !== productsValues[0].id
        ) {
          selectDefaults(productsValues);
        }
      } else if (
        productsValues.length > 0 &&
        selectedEditionId !== productsValues[0].id
      ) {
        selectDefaults(productsValues);
      }
    }
  }, [products]);

  const productsValues = products
    ? Object.values(products).filter(
      (product: any) => product.originalData.type.master
    )
    : [];

  const productsVariants =
    selectedEditionId && products[selectedEditionId]
      ? products[selectedEditionId].originalData.variants
      : [];

  const variationAttributes =
    selectedEditionId && products[selectedEditionId]
      ? products[selectedEditionId].originalData.variation_attributes
      : [];

  const selectedVariant =
    selectedEditionId &&
    selectedVariantId &&
    products[selectedEditionId] &&
    products[selectedEditionId].originalData &&
    products[selectedEditionId].originalData.variants.length
      ? formatProductInfo(
        products[selectedEditionId].originalData.variants.filter(
          (variant: any) => variant.id === selectedVariantId
        )
      )
      : null;

  // @ts-ignore
  const currency = window.GeoRestrictedResources
    ? window.GeoRestrictedResources.STOREFRONT_CURRENCY_CODE
    : null;
  // @ts-ignore
  const locale = window.GeoRestrictedResources
    ? formatLocale(window.GeoRestrictedResources.STOREFRONT_CURRENT_LOCALE)
    : null;
  // @ts-ignore
  const addProductUrl = window.Urls ? window.Urls.addProduct : null;

  return (
    <div className={'game-filters-container'}>
      {isProductsLoading ? (
        <Loader customColor='black' />
      ) : (
        <div className='game-filters'>
          <div className='game-filters-title'>{title}</div>
          <div className='filters-container-content'>
            <label>
              <div className='game-filter-label'>
                {comparison_table.select.edition}
              </div>
              {productsValues.length > 0 && (
                <div
                  className={`select-wrapper${
                    onlyCollectorEdition ? ' disabled' : ''
                  }`}
                >
                  <select
                    value={selectedEditionId}
                    disabled={onlyCollectorEdition}
                    onChange={(e) => changeSelectedEdition(e.target.value)}
                  >
                    {productsValues.map((product: any, index: number) => (
                      <option value={product.id} key={index}>
                        {product.name.edition}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </label>
            {variationAttributes.length > 0 &&
            variationAttributes.map(
              (variationAttribute: any, index: number) => (
                <label key={index}>
                  <div className='game-filter-label'>
                    {comparison_table.select.platform}
                  </div>
                  <div className='select-wrapper'>
                    <select
                      value={selectedVariantId}
                      onChange={(e) => setSelectedVariantId(e.target.value)}
                    >
                      {getVariantsList(productsVariants, variationAttribute)}
                    </select>
                  </div>
                </label>
              )
            )}
            {selectedVariant && (
              <div className='price-action'>
                <div className='price'>
                  {selectedVariant.newPriceExists && (
                    <div
                      className={`new${
                        selectedVariant.oldPriceExists ? ' with-old' : ''
                      }`}
                    >
                      {currencyFormatter(
                        selectedVariant.displayPrice.promotionalPrice,
                        locale,
                        currency,
                        {
                          shouldKeepEmptyDecimals: false
                        }
                      )}
                    </div>
                  )}
                  {selectedVariant.oldPriceExists && (
                    <div className='old'>
                      {currencyFormatter(
                        selectedVariant.displayPrice.regular,
                        locale,
                        currency,
                        {
                          shouldKeepEmptyDecimals: false
                        }
                      )}
                    </div>
                  )}
                </div>
                <div className='action'>
                  <a
                    href={addProductUrl + '?pid=' + selectedVariant.id}
                    className={
                      'buynow'
                    }
                    onClick={(e) =>
                      sendEvent(
                        `compare tab - add to cart - ${
                          selectedVariant.variation_values.Platform
                        } - rainbow six extraction - ${selectedVariant.edition.toLowerCase()}`,
                        {
                          PRODUCTID: selectedVariant.id,
                          PRODUCTNAME: `${
                            selectedVariant.variation_values.Platform
                          } - rainbow six extraction - ${selectedVariant.edition.toLowerCase()}`
                        }
                      )
                    }
                  >
                    {global.buy}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  loading: state.app.loading,
  products: state.app.products
});

export default connect(mapStateToProps)(withContent(Filter));
